import React from 'react';

import ButtonIcon from '~/components/ButtonIcon';
import PlayCircleOutline from '~/components/MaterialIcons/PlayCircleOutline';
import { StyledButton, StyledButtonText } from './WatchButton.styles';

type WatchButtonProps = {
	label: string;
	onClick: () => void;
};

const WatchButton = ({ label, onClick }: WatchButtonProps) => (
	<StyledButton color="grey" onClick={onClick} size="small" variant="text">
		<ButtonIcon size={17}>
			<PlayCircleOutline />
		</ButtonIcon>
		<StyledButtonText variant="button">{label}</StyledButtonText>
	</StyledButton>
);

export default WatchButton;
